import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';

class AppLoading extends Component {
  componentWillMount() {
    const preloader = document.getElementById('preloader-container');
    if (preloader && preloader.classList) {
      preloader.classList.add('app-loading');
    }
  }
  componentDidMount() {
    if (this.props.auth.isAuthenticated && !this.props.auth.isAuthenticating) {
      const { store } = this.context;
      store.dispatch(push('/'));
    }
  }
  componentWillUnmount() {
    const preloader = document.getElementById('preloader-container');
    if (preloader && preloader.classList) {
      preloader.classList.remove('app-loading');
    }
  }
  render() {
    return (<span />);
  }
}

AppLoading.propTypes = {
  auth: PropTypes.shape({
    isAuthenticated: PropTypes.bool,
    isAuthenticating: PropTypes.bool,
  }),
};

AppLoading.contextTypes = {
  store: PropTypes.object,
};

const mapStateToProps = state => ({
  auth: state.auth,
});

export default connect(mapStateToProps)(AppLoading);



// WEBPACK FOOTER //
// ./src/containers/AppLoading.jsx